// Maps each capability to the set of roles allowed to perform it. Roles are
// not implicitly nested; each row enumerates the set explicitly to mirror the
// master spec's permission matrix verbatim.
const MATRIX = {
    'item.view': new Set(['viewer', 'scorer', 'leader', 'admin']),
    'item.submit': new Set(['viewer', 'scorer', 'leader', 'admin']),
    'activity.view': new Set(['viewer', 'scorer', 'leader', 'admin']),
    'item.editIntake': new Set(['scorer', 'leader', 'admin']),
    'item.score': new Set(['scorer', 'leader', 'admin']),
    'item.advanceLifecycle': new Set(['scorer', 'leader', 'admin']),
    'item.setDecision': new Set(['leader', 'admin']),
    'item.priorityBandOverride': new Set(['leader', 'admin']),
    'item.markDone': new Set(['leader', 'admin']),
    'item.archive': new Set(['leader', 'admin']),
    'item.flagAnchor': new Set(['leader', 'admin']),
    'item.lifecycleBackward': new Set(['admin']),
    'settings.manage': new Set(['admin']),
    'excel.import': new Set(['admin']),
};
export function canPerform(actor, cap, 
// `item` is unused by the current matrix but kept on the signature so
// state-conditional capabilities (e.g. item.markDone requires lifecycle === 'Decided')
// can be tightened later without touching every call site.
_item) {
    const allowed = MATRIX[cap];
    const hit = actor.roles.some((r) => allowed.has(r));
    if (hit)
        return { allowed: true };
    return {
        allowed: false,
        reason: `role required for ${cap}: one of ${[...allowed].join(', ')}`,
    };
}
